module.exports = __webpack_public_path__ + "static/docs_page-1598865162bb9c7a26e1b8d08c197ab0.webp";